import { render, staticRenderFns } from "./pinFaq.vue?vue&type=template&id=3892ad9e&"
import script from "./pinFaq.vue?vue&type=script&lang=js&"
export * from "./pinFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports